'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _serializeJavascript = require('serialize-javascript');

var _serializeJavascript2 = _interopRequireDefault(_serializeJavascript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LaunchTagManager = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(LaunchTagManager, _React$Component);

  function LaunchTagManager() {
    (0, _classCallCheck3.default)(this, LaunchTagManager);
    return (0, _possibleConstructorReturn3.default)(this, (LaunchTagManager.__proto__ || (0, _getPrototypeOf2.default)(LaunchTagManager)).apply(this, arguments));
  }

  (0, _createClass3.default)(LaunchTagManager, [{
    key: 'renderDataLayerAssignment',
    value: function renderDataLayerAssignment() {
      var events = this.props.rawData.map(_serializeJavascript2.default).join(', ');
      return 'window.rawData=window.rawData||[' + events + '];window.__rawDataFromSSR=true;';
    }
  }, {
    key: 'render',
    value: function render() {
      if (__CLIENT__) return null;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactHelmet2.default, {
          script: [{
            type: 'text/javascript',
            src: this.props.oneTrustAutoblockEmbedCode
          }, {
            type: 'text/javascript',
            src: this.props.oneTrustConsentEmbedCode,
            'data-domain-script': this.props.oneTrustConsentDomainScript
          }, {
            type: 'text/javascript',
            innerHTML: 'function OptanonWrapper() {}'
          }, {
            type: 'text/javascript',
            innerHTML: this.renderDataLayerAssignment()
          }, {
            type: 'text/javascript',
            src: this.props.launchEmbedCode
          }]
        })
      );
    }
  }]);
  return LaunchTagManager;
}(_react2.default.Component), _class.propTypes = {
  rawData: _react.PropTypes.array,
  launchEmbedCode: _react.PropTypes.string.isRequired,
  oneTrustAutoblockEmbedCode: _react.PropTypes.string.isRequired,
  oneTrustConsentEmbedCode: _react.PropTypes.string.isRequired,
  oneTrustConsentDomainScript: _react.PropTypes.string.isRequired
}, _class.defaultProps = {
  rawData: []
}, _temp);
exports.default = LaunchTagManager;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/LaunchTagManager/index.js
// module id = 590
// module chunks = 0